<template>
  <AppHeaderDropdown right no-caret>
    <template slot="header">
      <img
        src="img/avatars/1.jpg"
        class="img-avatar"
        alt="admin@bootstrapmaster.com" />
    </template>
    <template slot="dropdown">
      <b-dropdown-header tag="div" class="text-center"><strong>Account</strong></b-dropdown-header>
      <b-dropdown-item v-on:click="profile"><i class="fa fa-user" /> Profile</b-dropdown-item>
      <b-dropdown-divider />
      <b-dropdown-item v-on:click="logOut"><i class="fa fa-lock" /> Logout</b-dropdown-item>
    </template>
  </AppHeaderDropdown>
</template>

<script>
    import { HeaderDropdown as AppHeaderDropdown } from '@coreui/vue'
    import router from '../router'
    import {LocalStorage} from "../services/LocalStorage/LocalStorage";

    export default {
        name: 'DefaultHeaderDropdownAccnt',
        components: {
            AppHeaderDropdown
        },
        methods: {
            logOut() {
                LocalStorage.clear(),
                router.push({name: 'Login'})
            },
            profile() {
                router.push({name: 'Profile'})
            },
        },
    }
</script>
